// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const VesselFrontSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M10.001 3C10.001 2.44772 10.4488 2 11.001 2H13.001C13.5533 2 14.001 2.44772 14.001 3V7H17.001C17.5533 7 18.001 7.44772 18.001 8V13.473L20.5952 14.3377C21.1841 14.534 21.4538 15.2139 21.1594 15.7605L18.366 20.9482C18.0172 21.596 17.3409 22 16.6051 22H7.39696C6.66119 22 5.98484 21.596 5.63602 20.9482L2.84262 15.7605C2.5483 15.2139 2.81792 14.534 3.40686 14.3377L6.00102 13.473V8C6.00102 7.44772 6.44873 7 7.00102 7H10.001V3ZM11.001 7H13.001V3H11.001V7ZM7.00102 13.1396L11.6848 11.5784C11.8901 11.5099 12.112 11.5099 12.3173 11.5784L17.001 13.1396V8H7.00102V13.1396ZM12.001 12.527L3.72309 15.2864L6.51649 20.4741C6.6909 20.798 7.02908 21 7.39696 21H16.6051C16.973 21 17.3112 20.798 17.4856 20.4741L20.279 15.2864L12.001 12.527Z" />
    </svg>
  )
}
